import { render, staticRenderFns } from "./InsidePlay.vue?vue&type=template&id=5a0060f6&scoped=true&"
import script from "./InsidePlay.vue?vue&type=script&lang=js&"
export * from "./InsidePlay.vue?vue&type=script&lang=js&"
import style0 from "./InsidePlay.vue?vue&type=style&index=0&id=5a0060f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0060f6",
  null
  
)

export default component.exports